import { useDispatch, useSelector } from "react-redux";
import "./CartSidebar.css";
import { changeQuantity, removeCartItem, selectCart } from "../shopPage/shopPageSlice";
import { selectCartSidebarOpen, setCartSidebarOpen } from "./cartSidebarSlice";
import { useNavigate } from "react-router";

export default function CartSidebar() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const cart = useSelector(selectCart);
    const cartSidebarIsOpen = useSelector(selectCartSidebarOpen);
    
    const cartTotal = cart.reduce((acc, cur) => {
        return acc + (cur.price * cur.quantity);
    }, 0)

    const handleCloseCartSidebarClick = () => {
        dispatch(setCartSidebarOpen(false));
    }

    const handleRemoveCartItemClick = (event) => {
        dispatch(removeCartItem(event.target.id))
    }

    const handleQuantityChange = (event) => {
        dispatch(changeQuantity({id: event.target.id, quantity: event.target.value}))
    }

    const handleStepDownClick = (event) => {
        const productId = event.target.id;
        const cartItemToUpdate = cart.find(item => item.id === productId);
        if (cartItemToUpdate.quantity > 1) {
            dispatch(changeQuantity({id: event.target.id, quantity: cartItemToUpdate.quantity - 1}))
        }
    }

    const handleStepUpClick = (event) => {
        const productId = event.target.id;
        const cartItemToUpdate = cart.find(item => item.id === productId);
        dispatch(changeQuantity({id: productId, quantity: cartItemToUpdate.quantity + 1}))
    }

    const handleCheckoutClick = (event) => {
        dispatch(setCartSidebarOpen(false));
        navigate('/shipping');
    }

    return (
        <section className={cartSidebarIsOpen ? "cartSidebarContainer active": "cartSidebarContainer inactive"}>
            <section className="cartSidebar">
                <div className="closeCartSidebarButton" onClick={handleCloseCartSidebarClick}>{">"}</div>
                <h4>Cart</h4>
                <table>
                    <thead>
                        <th>Remove</th>
                        <th>Product Name</th>
                        <th>Quantity</th>
                        <th>Unit Price</th>
                        <th>Total</th>
                    </thead>
                    <tbody>
                        {cart.map(product => {
                            return (
                                <tr>
                                    <td><div id={product.id} onClick={handleRemoveCartItemClick}>X</div></td>
                                    <td>{product.productName}</td>
                                    <td className="customNumber">
                                        <button id={product.id} onClick={handleStepDownClick}>-</button>
                                        <input type="number" value={product.quantity} id={product.id} onChange={handleQuantityChange} min={1}/>
                                        <button id={product.id} onClick={handleStepUpClick}>+</button>
                                    </td>
                                    <td>${(product.price / 100).toFixed(2)}</td>
                                    <td>${(product.price / 100 * product.quantity).toFixed(2)}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                <h5 className="cartTotal">Total: ${(cartTotal / 100).toFixed(2)}</h5>
                <button onClick={handleCheckoutClick}>Checkout</button>
            </section>
        </section>
        
    )
}